import getEnv from "env";
import { GraphQLClient } from "graphql-request";

export const getClient = (): GraphQLClient => {
  const ENV = getEnv();

  return new GraphQLClient(ENV.graphQLUrl, {
    credentials: "include",
  });
};
